// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { EngagementRingFiltersFragmentDoc } from '../../../graphql/api/product/rings/engagement/ring/fragments/engagementRingFilters.fragment.generated';
import { ProductGridFragmentDoc } from '../../../components/rings/product-grid/ProductGrid.generated';
import { ProductPageFacetedContentFragmentDoc } from '../../../graphql/api/product/faceted-content/productPageFacetedContent.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../graphql/api/cms/pageProductListing.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const EngagementRingBrowseDocument = gql`
    query engagementRingBrowse($currency: CurrencyInput!, $region: RegionCode!, $filter: CatalogueEngagementRingsFilterInput!, $page: Int!, $locale: Locale!, $limit: Int!, $path: String!, $facetedContentInput: ProductPageFacetedContentInput!, $sortBy: CatalogueSortOrder!) {
  catalogueEngagementRingFilters(input: $filter) {
    ...engagementRingFilters
  }
  catalogueEngagementRingsAggregate(filter: $filter) {
    count
  }
  catalogueEngagementRings(
    filter: $filter
    sort: {by: $sortBy, currency: $currency}
    pagination: {page: $page, limit: $limit}
  ) {
    ...productGrid
  }
  pageProductListingFacetedContent(input: $facetedContentInput, locale: $locale) {
    ...productPageFacetedContent
  }
  pageProductListing(path: $path, locale: $locale) {
    ...productPageListing
  }
}
    ${EngagementRingFiltersFragmentDoc}
${ProductGridFragmentDoc}
${ProductPageFacetedContentFragmentDoc}
${ProductPageListingFragmentDoc}`;

export function useEngagementRingBrowseQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.EngagementRingBrowseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.EngagementRingBrowseQuery, SchemaTypes.EngagementRingBrowseQueryVariables | undefined>({ query: EngagementRingBrowseDocument, variables: undefined, ...options });
};